/**
 * Section — vertical spacing wrapper for page sections.
 * Generous vertical rhythm using the spacing system.
 */

import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type SectionSpacing = 'none' | 'sm' | 'md' | 'lg' | 'xl';

export interface SectionProps extends HTMLAttributes<HTMLElement> {
  spacing?: SectionSpacing;
}

const spacingMap: Record<SectionSpacing, string> = {
  none: 'py-0',
  sm: 'py-12',
  md: 'py-20',
  lg: 'py-28',
  xl: 'py-40',
};

export const Section = forwardRef<HTMLElement, SectionProps>(
  ({ spacing = 'md', className, children, ...props }, ref) => {
    return (
      <section ref={ref} className={cn(spacingMap[spacing], className)} {...props}>
        {children}
      </section>
    );
  },
);

Section.displayName = 'Section';
